package com.essntl.core.settings.data.supabase.configuration

import com.essntl.core.settings.domain.model.configuration.ConfigurationLogoModel
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonIgnoreUnknownKeys

@Serializable
@OptIn(ExperimentalSerializationApi::class)
@JsonIgnoreUnknownKeys
data class ConfigurationLogoDto(
    val url: String?,
) {
    fun toModel() =
        ConfigurationLogoModel(url = url)
}